/**
 * Central handling for API error status codes (401 Unauthorized, 403 Forbidden, etc.).
 */

import { logout } from '../auth/okta';
import { appNavigate } from './appNavigation';

export function handleForbidden(): void {
  appNavigate('/forbidden', { replace: true });
}

/** Clear session and send user to login (unauthenticated / expired token). */
export function handleUnauthorized(): void {
  logout();
  // Pass the current page as `?from=` so Login.tsx stores it for post-auth redirect.
  const from = encodeURIComponent(window.location.pathname + window.location.search + window.location.hash);
  appNavigate(`/login?from=${from}`, { replace: true });
}

/**
 * Single entry for 401/403 side effects (axios, fetch, SSE, etc.).
 * @returns true if status was handled (caller may want to stop / throw)
 */
export function applyAuthErrorHandlers(status: number): boolean {
  if (status === 401) {
    handleUnauthorized();
    return true;
  }
  if (status === 403) {
    handleForbidden();
    return true;
  }
  return false;
}
